<script lang="ts" setup>
  import type { CardProps, CardSlots } from 'primevue/card'
  import type { VNode } from 'vue'

  defineProps<CardProps>()
  defineSlots<Omit<CardSlots, 'content'> & { default: VNode[] }>()
</script>

<template>
  <Card v-bind="$attrs">
    <!-- Header Slot -->
    <template
      v-if="$slots.header"
      #header>
      <slot name="header" />
    </template>

    <!-- Title Slot -->
    <template
      v-if="$slots.title"
      #title>
      <slot name="title" />
    </template>

    <!-- Subtitle Slot -->
    <template
      v-if="$slots.subtitle"
      #subtitle>
      <slot name="subtitle" />
    </template>

    <!-- Content Slot -->
    <template
      v-if="$slots.default"
      #content>
      <slot name="default" />
    </template>

    <!-- Footer Slot -->
    <template
      v-if="$slots.footer"
      #footer>
      <slot name="footer" />
    </template>
  </Card>
</template>
